<div class="white-box p-3 mb-3">
	<button #hiddenPrintBtn style="display: none" ngxPrint [useExistingCss]="true" printSectionId="to-print-content"
		printTitle="{{ device ? (('devices.charger_summary_report' | translate) + ' - ' + device.mac_address) : ('utilization.charger_fleet_site_summary_report' | translate) }}"></button>
	
	<!-- Print Modal -->
	<app-modal #printModal title="{{ device ? ('g.print_charger_summary_report' | translate) : ('g.print_charger_fleet_summary_report' | translate) }}" [hasCloseButton]="false"
		[hasConfirmButton]="false">
		<div class="p-3">
			<label class="mr-2">{{'rt_history.periods' | translate}}</label>
			<ng-select
				class="select"
				[items]="periods"
				[clearable]="false"
				[searchable]="false"
				bindLabel="label"
				bindValue="value"
				[placeholder]="'rt_history.periods' | translate"
				[(ngModel)]="printSelectedPeriod"
			></ng-select>

			<div class="mt-4 text-right">
				<button class="btn btn-primary" (click)="confirmPrint()">{{'g.print' | translate}}</button>
			</div>
		</div>
	</app-modal>
	
	<!-- Hidden Print Content -->
	<div class="print-content text-left" id="to-print-content">
		<ng-container *ngIf="!device">
			<!-- Header -->
			<div class="header-card">
				<div>
					<span class="title">{{ 'utilization.charger_fleet_site_summary_report' | translate}}</span>
					<div class="labels">
						<div class="label-content">
							<span>{{'g.site' | translate}}: </span>
							<p>
								<ng-container *ngIf="currentSite?.name">{{ currentSite?.name }} </ng-container> |
								<ng-container *ngIf="currentSite?.address">{{ currentSite?.address }}</ng-container>
							</p>
						</div>
						<div class="label-content">
							<span>{{'perf_analytic.period' | translate}}: </span>
							<p>{{ printPeriodText }}</p>
						</div>
					</div>
					</div>

				<div class="battery-count">
					<div class="d-flex align-items-center justify-content-around">
						<i class="fa fa-bolt icon"></i>
						<span class="count">{{ totalChargers }}</span>
					</div>
					<div class="total">{{'g.total_chargers' | translate}}</div>
				</div>
				</div>
			
			<h1 class="h3 m-4">{{ 'utilization.site_performance_scores' | translate }}</h1>
			
			<app-performance-score-widget
				[data]="printData"
				[devices]="devices"
				[scoreConfigs]="printScoreConfigs"
				[performance]="false"
				[userParentFilters]="true"
				[selectedPeriod]="printSelectedPeriod"
				[showNoData]="true"
			></app-performance-score-widget>
			
			<div class="metrics-row d-flex mt-4 pt-4" *ngIf="!noDataForPrintMetrics; else noDataTemplate">
				<app-utilization-metric-box
					class="w-50 ml-2 mt-0"
					[title]="'utilization.charger_fleet_max_daily_usage' | translate"
					[icon]="'fa fa-bar-chart'"
					[items]="printMaxDailyUsage"
				></app-utilization-metric-box>
				<app-utilization-metric-box
					class="w-50 ml-2 mt-0"
					[title]="'utilization.charger_fleet_average_daily_usage' | translate"
					[icon]="'fa fa-bar-chart'"
					[items]="printAverageDailyUsage"
				></app-utilization-metric-box>
			</div>
		</ng-container>
		
		<ng-container *ngIf="device">
			<div class="text-center w-100 mb-4 mt-2">
				<h3 class="font-weight-bold d-inline-block text-dark pb-1" style="border-bottom: 2px solid black !important; padding-bottom: 2px;">{{'devices.charger_summary_report' | translate}}</h3>
			</div>
		
			<table class="w-100 mt-3 mb-4 text-dark" style="border-collapse: collapse; text-align: center;">
				<tbody>
					<tr>
						<td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
							<strong>{{'g.date' | translate}}:</strong> {{ printDateText }}
						</td>
						<td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
							<strong>{{'devices.charger_id' | translate}}:</strong> {{ device?.config_info?.truck_id }}
						</td>
						</tr>
						<tr>
							<td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
								<strong>{{'g.site_name' | translate}}:</strong> {{ currentSite?.name }}
							</td>
							<td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
								<strong>{{'devices.charger_serial_number' | translate}}:</strong> {{ device?.config_info?.truck_sn || '-' }}
							</td>
						</tr>
						<tr>
							<td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
								<strong>{{'site_edit.address' | translate}}:</strong> {{ currentSite?.address }}
							</td>
							<td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
								<strong>{{'perf_analytic.period' | translate}}:</strong> {{ printPeriodText }}
							</td>
							<!-- <td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
													<strong>{{'devices.manuf_date' | translate}}:</strong> {{ device?.config_info?.truck_manufacturing_month }}/1/{{ device?.config_info?.truck_manufacturing_year }}
												</td> -->
						</tr>
						<tr>
							<td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
								<strong>{{'devices.charger_manufacturer' | translate}}:</strong> {{ device?.config_info?.truck_manufacturer ||
								'-' }}
							</td>
							<td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
								<strong>{{'g.weeks_of_operation' | translate}}:</strong> {{ operation_weeks || 0 }}
							</td>
						</tr>
						<tr>
							<td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
								<strong>{{'devices.charger_power_kw' | translate}}:</strong> {{ device?.config_info?.max_charger_kw ?? '-' }}
						</td>
						<td class="w-50 p-2" style="font-size: 14px; border: 1px solid black;">
						</td>
					</tr>
				</tbody>
			</table>
		
			<h5 class="mb-4 mt-3 pt-1 text-dark font-weight-bold">{{'utilization.charger_performance_scores' | translate}}</h5>
			<app-performance-score-widget
				[data]="printData"
				[devices]="devices"
				[scoreConfigs]="printScoreConfigs"
				[performance]="false"
				[userParentFilters]="true"
				[selectedPeriod]="printSelectedPeriod"
				[showNoData]="true"
			></app-performance-score-widget>
		
			<h5 class="mb-4 mt-3 pt-3 text-dark font-weight-bold">{{'utilization.charger_utilization_summary' | translate}}</h5>
			<div class="metrics-row d-flex mt-2 pt-2" *ngIf="!noDataForPrintMetrics; else noDataTemplate">
				<app-utilization-metric-box
					class="w-50 ml-2 mt-0"
					[title]="'utilization.charger_max_daily_usage' | translate"
					[icon]="'fa fa-line-chart'"
					[items]="printMaxDailyUsage"
					[theme]="'yellow'">
				</app-utilization-metric-box>
				<app-utilization-metric-box
					class="w-50 ml-2 mt-0"
					[title]="'utilization.charger_average_daily_usage' | translate"
					[icon]="'fa fa-bar-chart'"
					[items]="printAverageDailyUsage">
				</app-utilization-metric-box>
			</div>

			<h5 class="mb-4 mt-5 pt-1 ml-5 text-dark font-weight-bold">{{'utilization.max_kw_heat_map' | translate}}</h5>
			<div *ngIf="!noDataForPrintHeat; else noDataTemplate">
				<sct-charts
					[type]="'ColumnChart'"
					[title]=""
					[columnNames]="heatColumns"
					[data]="kwHeatData"
					[options]="kwChartOptions"
					[height]="200"
				></sct-charts>

				<div class="temp-legend">
					<div class="legend-item">
						<span class="legend-color red"></span>
						<span>{{'utilization.charger_kw' | translate}} >= {{ max_charger_daily_kw | number:'1.2-2' }}</span>
					</div>

					<div class="legend-item">
						<span class="legend-color blue"></span>
						<span> {{'utilization.charger_kw' | translate}} < {{ max_charger_daily_kw | number:'1.2-2' }}</span>
					</div>
				</div>
			</div>

			<h5 class="mb-4 mt-3 pt-1 ml-5 text-dark font-weight-bold">{{'utilization.max_kwh_heat_map' | translate}}</h5>
			<div *ngIf="!noDataForPrintHeat; else noDataTemplate">
				<sct-charts
					[type]="'ColumnChart'"
					[title]=""
					[columnNames]="heatColumns"
					[data]="kwhHeatData"
					[options]="kwhChartOptions"
					[height]="200"
				></sct-charts>

				<div class="temp-legend">
					<div class="legend-item">
						<span class="legend-color blue"></span>
						<span>{{'utilization.charger_kwh' | translate}} >= {{ min_charger_daily_kwh | number:'1.2-2' }}</span>
					</div>

					<div class="legend-item">
						<span class="legend-color brown"></span>
						<span> {{'utilization.charger_kwh' | translate}} < {{ min_charger_daily_kwh | number:'1.2-2' }}</span>
					</div>
				</div>
			</div>
		</ng-container>
	</div>

	<div class="filter-container mx-4 mb-5 position-relative" style="padding-right: 70px;">
		<div class="row">
			<div class="col-sm-6 col-md-4 col-lg-4 mt-4">
				<label for="periodSelect">{{"rt_history.periods" | translate}}</label>
				<ng-select
					class="select"
					[items]="periods"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'rt_history.periods' | translate"
					[(ngModel)]="selectedPeriod"
					(change)="prepareUtilizationData()"
				></ng-select>
			</div>

			<div class="col-sm-6 col-md-4 col-lg-4 mt-4">
				<label for="periodSelect">{{"g.working_days" | translate}}</label>
				<ng-select
					class="select"
					[items]="daysFilters"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'g.working_days' | translate"
					[(ngModel)]="selectedDaysFilter"
					(change)="prepareUtilizationData()"
				></ng-select>
			</div>

			<!-- voltage filter -->
			<div class="col-sm-6 col-md-4 col-lg-4 mt-4" *ngIf="voltagesOptions.length && !device">
				<label for="voltageSelect">{{"fleet_reports.charger_voltage" | translate}}</label>
				<ng-select
					id="voltageSelect"
					class="select"
					[items]="voltagesOptions"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'qv.voltage' | translate"
					[(ngModel)]="selectedVoltage"
					(change)="getChargersUtilizationData()"
				></ng-select>
			</div>

			<!-- Manufacturer filter -->
			<div class="col-sm-6 col-md-4 col-lg-4 mt-4" *ngIf="manufacturersOptions.length && !device">
				<label for="manufacturerSelect">{{"devices.charger_manufacturer" | translate}}</label>
				<ng-select
					id="manufacturerSelect"
					class="select"
					[items]="manufacturersOptions"
					[addTag]="false"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'devices.charger_manufacturer' | translate"
					[(ngModel)]="selectedManufacturer"
					(change)="getChargersUtilizationData()"
				></ng-select>
			</div>

			<!-- Vintage filter -->
			<!-- <div class="col-sm-6 col-md-4 col-lg-4 mt-4" *ngIf="!device">
				<label for="vintageSelect">{{"devices.charger_vintage" | translate}}</label>
				<ng-select
					name="vintageSelect"
					id="vintageSelect"
					class="select"
					[multiple]="true"
					[items]="vintageOptionsDropdown"
					[addTag]="true"
					[clearable]="false"
					[searchable]="false"
					bindLabel="label"
					bindValue="value"
					[placeholder]="'devices.charger_vintage' | translate"
					[(ngModel)]="selectedVintage"
					(ngModelChange)="vintageSelectionChanged()"
				>
					<ng-template ng-label-tmp let-item="item" let-clear="clear">
						<span>
							<span class="ng-value-icon left" (click)="clear(item)" aria-hidden="true">×</span>
							<span class="ng-value-label">{{item.label}}</span>
						</span>
					</ng-template>
				</ng-select>
			</div> -->
		</div>

		<div *ngIf="!device" class="position-absolute" style="top: 30px; right: 5px;">
			<button class="btn fa fa-print fa-lg print-btn " style="border: 1px solid #ddecfe; background-color: #f6fafe; color: #333; padding: 8px 12px; border-radius: 4px;" (click)="openPrintModal()" title="{{'g.print' | translate}}"></button>
		</div>
	</div>

	<div class="filter-container my-5 px-4">
		<h4 class="mb-4">{{(device ? 'utilization.charger_performance_scores' : 'utilization.site_performance_scores') | translate}}</h4>
		<app-performance-score-widget
			*ngIf="!noData; else noDataTemplate"
			[data]="data"
			[devices]="devices"
			[scoreConfigs]="scoreConfigs"
			[performance]="false"
			[userParentFilters]="true"
			[selectedDaysFilter]="selectedDaysFilter"
			[selectedPeriod]="selectedPeriod"
		></app-performance-score-widget>
	</div>

	<app-charger-utilization-score
		*ngIf="data && !device"
		[utilizationScoreData]="chargerUtilizationScore"
		[chargerAhScore]="chargerAhScore"
		[chargerKwhScore]="chargerKwhScore"
		[devices]="devices"
		[userParentFilters]="true"
		[selectedPeriod]="selectedPeriod"
	></app-charger-utilization-score>

	<div class="my-5 px-4">
		<h4 class="mb-4">{{(device ? 'utilization.charger_utilization_summary' : 'utilization.charger_fleet_performance_metrics') | translate}}</h4>
		
		<div class="metrics-row" *ngIf="!noData; else noDataTemplate">
			<app-utilization-metric-box
				class="ml-2"
				[title]="(device ? 'utilization.charger_max_daily_usage' : 'utilization.charger_fleet_max_daily_usage') | translate"
				[icon]="'fa fa-line-chart'"
				[items]="maxDailyUsage"
				[theme]="'yellow'"
			></app-utilization-metric-box>

			<app-utilization-metric-box
				class="ml-2"
				[title]="(device ? 'utilization.charger_average_daily_usage' : 'utilization.charger_fleet_average_daily_usage') | translate"
				[icon]="'fa fa-bar-chart'"
				[items]="averageDailyUsage"
			></app-utilization-metric-box>
		</div>
	</div>

	<app-daily-charger-utilization *ngIf="!device"></app-daily-charger-utilization>
</div>

<ng-template #noDataTemplate class="mt-4">
	<div class="alert alert-info">{{'g.no_data_to_show' | translate}}</div>
</ng-template>
